import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import EditOrganisationForm from 'components/organisms/EditOrganisationForm'

export const styles = () => ({
  root: {},
})

const OrganisationOverview = ({ classes, organisation, onFormSubmit }) => (
  <div className={classes.root}>
    <EditOrganisationForm
      organisation={organisation}
      onFormSubmit={onFormSubmit}
    />
  </div>
)

OrganisationOverview.propTypes = {
  onFormSubmit: PropTypes.func,
  classes: PropTypes.object.isRequired,
  organisation: PropTypes.object.isRequired,
}

export default withStyles(styles)(OrganisationOverview)



// WEBPACK FOOTER //
// ./src/containers/organisation/OrganisationOverview/OrganisationOverview.js